
/**
 * When the tablet or mobile menus are active we want the body to have overflow:hidden and then to replace it
 *     when the menus are closed.
 * @param {Boolean} hide
 */
let bodyOverflowOverridden = false;

export default function setBodyOverflow(hide) {
    if ((bodyOverflowOverridden && hide) || (!bodyOverflowOverridden && !hide)) return;
    const className = ' egh-hide-overflow';

    if (hide) {
        document.body.className += className;
        bodyOverflowOverridden = true;
    } else {
        document.body.className = document.body.className.replace(className, '');
        bodyOverflowOverridden = false;
    }
}



// WEBPACK FOOTER //
// ./app/scripts/utils/bodyUtils.js